import React, { useEffect, useState, useRef, useMemo } from "react";
import { isEqual, debounce } from "lodash";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { useTranslation } from "react-i18next/";
import { useSnapshot } from "valtio";
import { useLocation } from "react-router-dom";

import { store } from "./Kiosk/store";
import { store as userStore } from "@components/VerticalLayout/store";
import {
    store as appStore,
    setIsAddAppClicked,
    setIsDeletePeripheralModalOpened,
    setGlobalDataIsUpdated,
    setIsMultiDeletePeripheralModalOpened,
    setIsActionsClicked,
    setActions,
    setValidationAction,
    setIsEdited,
    setIsLoading,
    setKey,
} from "./store";
import { useMergedAppsForMoneticStore } from "./PeripheralConfigure/MoneticPeripheralConfigure/useMergedAppsForMoneticStore";
import { setSelectedMonnyeur } from "@pages/Peripherals/CashManagement/store";
import { setModify, setAllSelectedRows } from "./store";

import PageTitle from "@components/Common/PageTitle";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import { useCallbackPrompt } from "@hooks/useCallbackPrompt";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { getPathAuthorization } from "@components/VerticalLayout";
import { DropdownConfigure } from "./DropdownConfigure";
import AddApplication from "./AddApplication";
import { CustomIcons } from "./CustomIcons";
import { DropdownStatus } from "./DropdownStatus";
import BadgeNumber from "@components/Common/BadgeNumber";
import { ActionColumn } from "./ActionColumn";
import { ConfirmationMessage } from "@components/Common/ConfirmationMessage";
import { AppUid } from "./AppUid";
import HeaderApplication from "./HeaderApplication";
import View from "./View";
import HistoryApplication from "./HistoryApplication";
import Configuration from "./Configuration";
import AssociateModal from "./AssociateModal";
import Delete from "./Delete";

import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { useSelector } from "react-redux";
import { useAuthHeader } from "../../api/headersKeycloak";
import { useFetchGlobal } from "../../api/hooks";

type CustomColumnProps = {
    indexOFColumn: number;
    columnName: string;
    customJsx: React.ReactNode;
};

export default function Applications() {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();
    const { fetchGlobal } = useFetchGlobal();
    const location = useLocation();
    const authorizationList = useSelector(
        (state: any) => state.global.infoUser.profileAuthorization
    );
    setModify(
        getPathAuthorization(location.pathname, authorizationList).Modifie
    );
    const {
        oneShop,
        userID,
        franchiseID,
        shopID,
        operatorID,
        isModalConfirmationOpened,
    } = useSnapshot(userStore);
    const {
        isDeletePeripheralModalOpened,
        isAddAppClicked,
        globalDataIsUpdated,
        isMultiDeletePeripheralModalOpened,
        isEdited,
        actions,
        validationAction,
        isActionsClicked,
        modify,
        key,
    } = useSnapshot(appStore);
    const { displayMode } = useSnapshot(store);
    const [isConsult, setIsConsult] = React.useState<boolean>(false);
    const appId = "KIOSK";
    const didMountRef = React.useRef(false);
    const [isHistoryModalOpened, setIsHistoryModalOpened] = useState(false);
    const [
        isHistoryModalCashMangmentOpened,
        setIsHistoryModalCashMangmentOpened,
    ] = useState(false);
    const [
        isHistoryMoneticsModalOpened,
        setIsHistoryMoneticsModalOpened,
    ] = useState(false);
    const [isAddNewAppButtonClicked, setIsAddNewAppButtonClicked] = useState(
        false
    );
    const [urlHistoryPrinter, setUrlHistoryPrinter] = useState<string>(``);

    const [
        isAddPrinterOriginHistoryClicked,
        setIsAddPrinterOriginHistoryClicked,
    ] = React.useState<boolean>(false);
    const [
        isInitializationModalOpened,
        setIsInitializationModalOpened,
    ] = useState(false);
    const [isModalOpened, setIsModalOpened] = useState(false);
    const [
        isMoneticsPathsModalOpened,
        setIsMoneticsPathsModalOpened,
    ] = useState(false);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );
    const [applicationChildrenId, setApplicationChildrenId] = React.useState<
        string
    >("");
    const [selectedIds, setSelectedIds] = React.useState<any>([]);
    const [ListNumberOrigin, setListNumberOrigin] = React.useState<any>({
        nbrNotArchived: 0,
        nbrArchived: 0,
    });
    const [typeDisplay, setTypeDisplay] = React.useState<string>("notArchived");
    const [shopId, setShopId] = React.useState<number>();
    const [peripheralId, setPeripheralId] = React.useState<string>("");
    const [data, setData] = React.useState<any>({});
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [isAssociateModalOpened, setIsAssociateModalOpened] = React.useState<
        boolean
    >(false);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");
    const [
        isConfirmationEditModalOpened,
        setIsConfirmationEditModalOpened,
    ] = React.useState<boolean>(false);
    const [isDisplayModeChanged, setIsDisplayModeChanged] = React.useState<
        boolean
    >(false);
    const {
        isConfigurationCashManagementClicked,
        isConfigurationPrinterClicked,
    } = useSnapshot(store);
    const [rowData, setRowData] = useState<any>({});

    const [apiUrl, setApiUrl] = useState<any>("");
    const [textModal, setTextModal] = useState<any>("");

    const fetchTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const peripheralUrl = useMemo(() => {
        return oneShop
            ? displayMode === t("View by device")
                ? `/settings/applications/oneShop/devices?userId=${userID}&franchiseId=${franchiseID}&appId=${appId}&shopId=${shopID}&typeDisplay=${typeDisplay}`
                : `/settings/applications/list?userId=${userID}&franchiseId=${franchiseID}&appId=${appId}&shopId=${shopID}&typeDisplay=${typeDisplay}`
            : displayMode === t("View by device")
            ? `/settings/applications/devices?userId=${userID}&franchiseId=${franchiseID}&appId=${appId}&typeDisplay=${typeDisplay}&uuidUser=${uuidUser}`
            : `/settings/applications?userId=${userID}&franchiseId=${franchiseID}&appId=${appId}&typeDisplay=${typeDisplay}&uuidUser=${uuidUser}`;
    }, [
        oneShop,
        displayMode,
        t,
        userID,
        franchiseID,
        appId,
        shopID,
        typeDisplay,
        uuidUser,
    ]);

    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const [shopIds, setShopIds] = React.useState<any[]>([]);
    const [applicationsShopIds, setApplicationsShopIds] = React.useState<any[]>(
        []
    );
    const [publishedShops, setPublishedShops] = React.useState<any[]>([]);

    const [shopNames, setShopNames] = React.useState<any>([]);

    const [editedData, setEditedData] = React.useState<any>([]);
    const [isComingFromModify, setIsComingFromModify] = React.useState<boolean>(
        false
    );
    const [inputDesignation, setInputDesignation] = React.useState<boolean>(
        false
    );
    const [
        isModalDeleteAssociatePeripheralOpened,
        setIsModalDeleteAssociatePeripheralOpened,
    ] = React.useState<boolean>(false);
    const [shops, setShops] = React.useState<any>([]);
    const [redisData, setRedisData] = React.useState<any>([]);

    let arrayOfCustomColumns: CustomColumnProps[] = [
        {
            indexOFColumn: oneShop ? 1 : 2,
            columnName:
                displayMode === t("View by device")
                    ? t("Peripheral")
                    : t("Application"),
            customJsx: (e: any) => {
                return displayMode === t("View by device") ? (
                    oneShop ? (
                        e.selectedRow[t("Peripheral")]
                    ) : e.selectedRow[t("Shop")] !== "" &&
                      e.selectedRow.subRows?.length >= 0 ? (
                        <BadgeNumber value={e.selectedRow.subRows?.length} />
                    ) : (
                        e.selectedRow[t("Peripheral")]
                    )
                ) : oneShop ? (
                    e.selectedRow[t("Application")]
                ) : e.selectedRow[t("Shop")] !== "" &&
                  e.selectedRow.subRows?.length >= 0 ? (
                    <BadgeNumber value={e.selectedRow.subRows?.length} />
                ) : (
                    e.selectedRow[t("Application")]
                );
            },
        },
        {
            indexOFColumn: oneShop ? 2 : 3,
            columnName: t("UID"),
            customJsx: (e: any) => {
                return <AppUid e={e} />;
            },
        },
        {
            indexOFColumn: oneShop
                ? displayMode === t("View by device")
                    ? 2
                    : 3
                : displayMode === t("View by device")
                ? 3
                : 4,
            columnName:
                displayMode !== t("View by device")
                    ? t("Peripheral")
                    : t("Application"),
            customJsx: (e: any) => {
                return displayMode !== t("View by device")
                    ? e.selectedRow[t("Peripheral")] !== undefined
                        ? e.selectedRow[t("Peripheral")]
                        : ""
                    : e.selectedRow[t("Application")];
            },
        },
        {
            indexOFColumn: 997,
            columnName: t("Status"),
            customJsx: (e: any) => {
                return e.selectedRow["Application"] !== "" &&
                    e.selectedRow[t("Shop")] === "" ? (
                    <DropdownStatus
                        state="In line"
                        typeDisplay={typeDisplay}
                        data={e.selectedRow}
                        franchiseID={franchiseID}
                    />
                ) : e.selectedRow[t("Peripheral")] !== "" &&
                  e.selectedRow[t("Shop")] === "" ? (
                    <DropdownStatus
                        state="In line"
                        typeDisplay={typeDisplay}
                        data={e.selectedRow}
                        franchiseID={franchiseID}
                    />
                ) : null;
            },
        },
        {
            indexOFColumn: oneShop ? 6 : 7,
            columnName: t("Ticket"),
            customJsx: (e: any) => {
                return e.selectedRow["tickets"] !== undefined &&
                    e.selectedRow["tickets"] !== "" &&
                    e.selectedRow[t("Application")] === ""
                    ? t(e.selectedRow["tickets"].label)
                    : null;
            },
        },
        {
            indexOFColumn: 998,
            columnName: t("Setup status"),
            customJsx: (e: any) => {
                return e.selectedRow["Application"] !== "" &&
                    e.selectedRow[t("Shop")] === "" ? (
                    <DropdownConfigure
                        state={e.selectedRow[t("State")]}
                        typeDisplay={typeDisplay}
                        data={e.selectedRow}
                    />
                ) : e.selectedRow[t("Peripheral")] !== "" &&
                  e.selectedRow[t("Shop")] === "" ? (
                    <DropdownConfigure
                        state={e.selectedRow[t("State")]}
                        typeDisplay={typeDisplay}
                        data={e.selectedRow}
                    />
                ) : null;
            },
        },
        {
            indexOFColumn: 999,
            columnName: t("Actions"),
            customJsx: (e: any) => {
                return (
                    <CustomIcons
                        e={e}
                        setShopId={setShopId}
                        setRowData={setRowData}
                        setPeripheralId={setPeripheralId}
                        setIsModalOpened={setIsModalOpened}
                        isModalOpened={isModalOpened}
                        setIsMoneticsPathsModalOpened={
                            setIsMoneticsPathsModalOpened
                        }
                        isMoneticsPathsModalOpened={isMoneticsPathsModalOpened}
                        setIsAssociateModalOpened={setIsAssociateModalOpened}
                        isAssociateModalOpened={isAssociateModalOpened}
                        setIsDeletePeripheralModalOpened={
                            setIsDeletePeripheralModalOpened
                        }
                        setApplicationChildrenId={setApplicationChildrenId}
                        setApiUrl={setApiUrl}
                        isConfigurationCashManagementClicked={
                            isConfigurationCashManagementClicked
                        }
                        setIsModalDeleteAssociatePeripheralOpened={
                            setIsModalDeleteAssociatePeripheralOpened
                        }
                        setTextModal={setTextModal}
                        typeDisplay={typeDisplay}
                        setSelectedRows={setSelectedRows}
                        setIsHistoryModalOpened={setIsHistoryModalOpened}
                        setIsConsult={setIsConsult}
                        setEditedData={setEditedData}
                        setIsComingFromModify={setIsComingFromModify}
                        setIsHistoryMoneticsModalOpened={
                            setIsHistoryMoneticsModalOpened
                        }
                        setIsHistoryModalCashMangmentOpened={
                            setIsHistoryModalCashMangmentOpened
                        }
                        setUrlHistoryPrinter={setUrlHistoryPrinter}
                        setIsAddPrinterOriginHistoryClicked={
                            setIsAddPrinterOriginHistoryClicked
                        }
                        selectedRows={selectedRows}
                    />
                );
            },
        },
    ];

    async function getPublish() {
        const shopList = await fetchGlobal<any>(
            `${process.env.REACT_APP_API_V2_URL}/settings/application/publishedShops?franchiseId=${franchiseID}`,
            { method: "GET" }
        );
        setShops(shopList.data.map((el: any) => el.shopId));
        setPublishedShops(shopList.data);
    }

    React.useEffect(() => {
        setIsAddAppClicked(false);
        setEditedData([]);
        if (didMountRef.current) {
            setGlobalDataIsUpdated(true);
        } else {
            didMountRef.current = true;
        }
    }, [i18nextLng]);

    React.useEffect(() => {
        if (globalDataIsUpdated) {
            if (fetchTimeoutRef.current) {
                clearTimeout(fetchTimeoutRef.current);
            }

            fetchTimeoutRef.current = setTimeout(() => {
                setGlobalDataIsUpdated(false);
            }, 100);

            return () => {
                if (fetchTimeoutRef.current) {
                    clearTimeout(fetchTimeoutRef.current);
                }
            };
        }
    }, [globalDataIsUpdated]);

    React.useEffect(() => {
        setListNumberOrigin(data?.othersData?.ListNumberOrigin);
    }, [data]);

    const mergedLocalApps = useMemo(() => data?.data ?? [], [data]);
    // `?? {}` makes the silent-degradation choice explicit when the BE payload
    // omits `peripheralsInUse` (old BE / contract drift) — see hook contract.
    const peripheralsInUse = useMemo(
        () => data?.othersData?.peripheralsInUse ?? {},
        [data]
    );
    useMergedAppsForMoneticStore({
        localApps: mergedLocalApps,
        peripheralsInUse,
        oneShop,
    });

    React.useEffect(() => {
        setIsEdited(false);
        if (isAddAppClicked === false) setEditedData([]);
    }, [isAddAppClicked]);

    function useStableSelectedRowsEffect(
        selectedRows: any[],
        dependencies: any[],
        callback: (stableRows: any[]) => void
    ) {
        const prevRowsRef = useRef<any[]>([]);
        const debouncedCallbackRef = useRef(
            debounce((rows: any[]) => {
                callback(rows);
            }, 300)
        );

        useEffect(() => {
            if (!isEqual(prevRowsRef.current, selectedRows)) {
                prevRowsRef.current = selectedRows;
                debouncedCallbackRef.current(selectedRows);
            }

            return () => {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                debouncedCallbackRef.current.cancel();
            };
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [selectedRows, ...dependencies]);
    }

    useStableSelectedRowsEffect(
        selectedRows,
        [
            displayMode,
            typeDisplay,
            userID,
            franchiseID,
            shopID,
            operatorID,
            uuidUser,
            shops,
            publishedShops,
            t,
        ],
        (stableRows) => {
            const ids: any[] = [];
            const selectedShopsIds: any[] = [];
            const shopsNames: string[] = [];
            const applicationShopIds: any[] = [];
            const monnyeurMap: any[] = [];

            const isDeviceView = displayMode === t("View by device");
            const isArchivedValue =
                typeDisplay === "notArchived" ? "true" : "false";

            stableRows.forEach((el: any) => {
                const hasNoSubRows = el.subRows === undefined;
                const hasNoShop = !el[t("Shop")];
                const isOneShop = !!oneShop;

                if (isDeviceView && hasNoSubRows) {
                    ids.push({
                        Id: el.appId,
                        isArchived: isArchivedValue,
                        shopId: el.shopId,
                        userID,
                        franchiseID,
                    });
                } else if (
                    !isDeviceView &&
                    hasNoShop &&
                    (!isOneShop || (isOneShop && el.subRows))
                ) {
                    ids.push({
                        Id: el.appId,
                        isArchived: isArchivedValue,
                        shopId: el.shopId,
                        userID,
                        franchiseID,
                        operatorID,
                        uuidUser,
                    });
                } else if (
                    isOneShop &&
                    hasNoSubRows &&
                    !isDeviceView &&
                    (!el[t("Application")] || !el[t("Peripheral")])
                ) {
                    ids.push({
                        Id: el.appId,
                        isArchived: isArchivedValue,
                        shopId: shopID,
                        userID,
                        franchiseID,
                        operatorID,
                        uuidUser,
                    });
                }

                if (el[t("Shop")]) {
                    selectedShopsIds.push(el.shopId);
                    if (shops.includes(el.shopId)) {
                        shopsNames.push(el[t("Shop")]);
                    }
                } else {
                    applicationShopIds.push(el.shopId);
                    const exist = publishedShops.find(
                        (p: any) => p.shopId === el.shopId
                    );
                    if (exist) {
                        shopsNames.push(exist.name);
                    }
                }

                monnyeurMap.push({ [el.shopId]: el.peripheralId });
            });

            setSelectedIds(ids);
            setRedisData(ids.filter((el: any) => shops.includes(el.shopId)));
            setShopIds(selectedShopsIds);
            setApplicationsShopIds(applicationShopIds);
            setShopNames([...new Set(shopsNames)]);
            setSelectedMonnyeur(monnyeurMap);
            setAllSelectedRows(stableRows);
        }
    );

    React.useEffect(() => {
        if (isAddAppClicked && didMountRef.current) {
            setActions(confirmNavigation);
            setIsActionsClicked(showPrompt as boolean);
            setValidationAction(cancelNavigation);
        } else {
            didMountRef.current = true;
        }
    }, [isAddAppClicked, showPrompt, confirmNavigation, cancelNavigation]);

    React.useEffect(() => {
        getPublish();
        //eslint-disable-next-line
    }, []);

    const dynamicTableProps = useMemo(
        () => ({
            key: key,
            showFilter: true,
            url: `${process.env.REACT_APP_API_V2_URL}${peripheralUrl}`,
            name: displayMode,
            requestHeader: {
                "Accept-Language": i18nextLng,
                ...getAuthHeader,
            },
            customJsxSideFilterButton: (
                <AddApplication
                    setIsComingFromModify={setIsComingFromModify}
                    isComingFromModify={isComingFromModify}
                    isAddAppClicked={isAddAppClicked}
                    setIsAddAppClicked={setIsAddAppClicked}
                    selectedRows={selectedRows}
                    isEdited={isEdited}
                    setIsInitializationModalOpened={
                        setIsInitializationModalOpened
                    }
                    oneShop={oneShop}
                    setDataIsUpdated={setGlobalDataIsUpdated}
                    typeDisplay={typeDisplay}
                    setTypeDisplay={setTypeDisplay}
                    selectedIds={selectedIds}
                    ListNumberOrigin={ListNumberOrigin}
                    setIsHistoryModalOpened={setIsHistoryModalOpened}
                    shopIds={shopIds}
                    setIsAssociateModalOpened={setIsAssociateModalOpened}
                    isDisplayModeChanged={isDisplayModeChanged}
                    setIsDisplayModeChanged={setIsDisplayModeChanged}
                    setShopIds={setShopIds}
                />
            ),
            setDataIsUpdated: setGlobalDataIsUpdated as
                | React.Dispatch<React.SetStateAction<number | boolean>>
                | undefined,
            dataIsUpdated: globalDataIsUpdated,
            canResize: true,
            setData: setData,
            showGlobalFilter: true,
            arrayOfCustomColumns: arrayOfCustomColumns,
            filterActive: filterActive,
            setLocalFilterActive: setLocalFilterActive,
            elevationTable: 1,
            minHeight: "500px",
            maxHeight: "500px",
            canExpand: true,
            canSelect: true,
            customSelect: true,
            setSelectedRows: setSelectedRows,
            canMovedCheckboxLeftOnExpand: true,
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            key,
            peripheralUrl,
            displayMode,
            i18nextLng,
            globalDataIsUpdated,
            isAddAppClicked,
            selectedRows,
            isEdited,
            oneShop,
            typeDisplay,
            selectedIds,
            ListNumberOrigin,
            shopIds,
            isDisplayModeChanged,
            arrayOfCustomColumns,
            filterActive,
        ]
    );

    return (
        <React.Fragment>
            <PageTitle title={t("Applications")} />
            <div className="page-content__clz">
                <HeaderApplication
                    oneShop={oneShop}
                    typeDisplay={typeDisplay}
                    t={t}
                />

                <div
                    style={{
                        display: "grid",
                        minHeight: "650px",
                        gridTemplateColumns: isAddAppClicked
                            ? "2fr 1fr "
                            : "auto",
                        gridColumnGap: "4px",
                        border: 0,
                    }}
                >
                    <DynamicTable
                        {...dynamicTableProps}
                        actionColumn={(e: any) =>
                            modify === true &&
                            e.selectedRow.original.mark !== "Adyen" ? (
                                <>
                                    <ActionColumn
                                        e={e}
                                        displayMode={displayMode}
                                        typeDisplay={typeDisplay}
                                    />
                                </>
                            ) : null
                        }
                    />
                    {isAddAppClicked && (
                        <View
                            displayMode={displayMode}
                            t={t}
                            setIsAddAppClicked={setIsAddAppClicked}
                            isAddAppClicked={isAddAppClicked}
                            setGlobalDataIsUpdated={setGlobalDataIsUpdated}
                            isAddNewAppButtonClicked={isAddNewAppButtonClicked}
                            selectedRows={selectedRows}
                            editedData={editedData}
                            isComingFromModify={isComingFromModify}
                            inputDesignation={inputDesignation}
                            setInputDesignation={setInputDesignation}
                            setIsConfirmationEditModalOpened={
                                setIsConfirmationEditModalOpened
                            }
                            data={data}
                            isConsult={isConsult}
                            setIsConsult={setIsConsult}
                            shopIds={shopIds}
                            setSelectedRows={setSelectedRows}
                            setEditedData={setEditedData}
                            setIsEdited={setIsEdited}
                            isEdited={isEdited}
                        />
                    )}
                    <Configuration
                        isConfigurationPrinterClicked={
                            isConfigurationPrinterClicked
                        }
                        isConfigurationCashManagementClicked={
                            isConfigurationCashManagementClicked
                        }
                        rowData={rowData}
                        setRowData={setRowData}
                        oneShop={oneShop}
                        setGlobalDataIsUpdated={setGlobalDataIsUpdated}
                        isMoneticsPathsModalOpened={isMoneticsPathsModalOpened}
                        userID={userID}
                        shopId={shopId}
                        franchiseID={franchiseID}
                        appId={appId}
                        applicationChildrenId={applicationChildrenId}
                        setIsMoneticsPathsModalOpened={
                            setIsMoneticsPathsModalOpened
                        }
                        displayMode={displayMode}
                    />
                </div>
            </div>
            <AssociateModal
                displayMode={displayMode}
                t={t}
                isAssociateModalOpened={isAssociateModalOpened}
                setIsAssociateModalOpened={setIsAssociateModalOpened}
                rowData={rowData}
                globalDataIsUpdated={globalDataIsUpdated}
                setGlobalDataIsUpdated={setGlobalDataIsUpdated}
                oneShop={oneShop}
                selectedRows={selectedRows}
            />
            <Delete
                isMultiDeletePeripheralModalOpened={
                    isMultiDeletePeripheralModalOpened
                }
                setIsMultiDeletePeripheralModalOpened={
                    setIsMultiDeletePeripheralModalOpened
                }
                typeDisplay={typeDisplay}
                oneShop={oneShop}
                shops={shops}
                shopID={shopID}
                t={t}
                applicationsShopIds={applicationsShopIds}
                shopNames={shopNames}
                redisData={redisData}
                isModalDeleteAssociatePeripheralOpened={
                    isModalDeleteAssociatePeripheralOpened
                }
                textModal={textModal}
                setIsModalDeleteAssociatePeripheralOpened={
                    setIsModalDeleteAssociatePeripheralOpened
                }
                isModalOpened={isModalOpened}
                setIsModalOpened={setIsModalOpened}
                setGlobalDataIsUpdated={setGlobalDataIsUpdated}
                apiUrl={apiUrl}
                isDeletePeripheralModalOpened={isDeletePeripheralModalOpened}
                displayMode={displayMode}
                rowData={rowData}
                shopId={shopId}
                userID={userID}
                franchiseID={franchiseID}
                appId={appId}
                applicationChildrenId={applicationChildrenId}
                peripheralId={peripheralId}
                operatorID={operatorID}
                uuidUser={uuidUser}
                setKey={setKey}
                setIsLoading={setIsLoading}
            />

            <HistoryApplication
                selectedRows={selectedRows}
                isHistoryModalOpened={isHistoryModalOpened}
                setIsHistoryModalOpened={setIsHistoryModalOpened}
                setGlobalDataIsUpdated={setGlobalDataIsUpdated}
                isHistoryMoneticsModalOpened={isHistoryMoneticsModalOpened}
                setIsHistoryMoneticsModalOpened={
                    setIsHistoryMoneticsModalOpened
                }
                isHistoryModalCashMangmentOpened={
                    isHistoryModalCashMangmentOpened
                }
                setIsHistoryModalCashMangmentOpened={
                    setIsHistoryModalCashMangmentOpened
                }
                isAddPrinterOriginHistoryClicked={
                    isAddPrinterOriginHistoryClicked
                }
                urlHistoryPrinter={urlHistoryPrinter}
                setIsAddPrinterOriginHistoryClicked={
                    setIsAddPrinterOriginHistoryClicked
                }
                displayMode={displayMode}
            />

            {isModalConfirmationOpened ? <ConfirmationMessage /> : null}
            {isInitializationModalOpened === true ? (
                <ConfirmationInitializationMessage
                    isModalOpened={isInitializationModalOpened}
                    setIsModalOpened={setIsInitializationModalOpened}
                    setIsClicked={setIsAddNewAppButtonClicked}
                    isClicked={isAddNewAppButtonClicked}
                    setIsEdited={setIsEdited}
                />
            ) : null}
            {isConfirmationEditModalOpened ? (
                <ConfirmationEditMessage
                    isModalOpened={isConfirmationEditModalOpened}
                    setIsModalOpened={setIsConfirmationEditModalOpened}
                    setIsAddClicked={setIsAddAppClicked}
                />
            ) : null}

            {isActionsClicked === true ? (
                <ConfirmationUpdatingDataMessageModal
                    isModalOpened={isActionsClicked}
                    setIsModalOpened={setIsActionsClicked}
                    validationAction={validationAction}
                    actions={actions}
                    setIsEdited={setIsEdited}
                />
            ) : null}
        </React.Fragment>
    );
}
